import WebsiteBehaviors from "../website-behaviors/index.js";
import Selection from "../selection.js";

class Unizin extends WebsiteBehaviors {
	identifier() {
		return "Unizin";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host.match(/^(.+\.)?courseload\.com$/);
	}

	styles() {
		// language=CSS
		return `
			/* Hide text highlights but only when not creating them (click+drag) */
			g.highlight[role=button] {
				display: none;
			}

			/* Hide their notifications (e.g. "Your note was created successfully") */
			.notification-wrapper {
				display: none;
			}
		`;
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	mouseDown(event, bypassHighlightRules) {
		if (document.querySelector(".svg-reader")) { // Is this the PDF viewer?
			// Record the number of boxes acting as "text selection" inside the svg
			const value = document.querySelectorAll(".svg-reader svg rect.selectedword").length.toString();
			document.documentElement.setAttribute("pn-text-selection-boxes", value);
		}
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
	async mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy) {
		if (document.querySelector(".svg-reader")) { // Is this the PDF viewer?
			const textHasBeenSelected = document.querySelectorAll(".svg-reader svg rect.selectedword").length.toString() !== document.documentElement.getAttribute("pn-text-selection-boxes");

			if (!textHasBeenSelected)
				return false;

			await new Promise(resolve => setTimeout(resolve, 500));

			const clipboardElem = document.querySelector(".svg-reader .clipboard");
			const content = (clipboardElem as HTMLElement)?.innerText.trim();
			if (content === "")
				return false;

			const range = new Range();
			// @ts-expect-error TS(2345) FIXME: Argument of type 'Element | null' is not assignabl... Remove this comment to see the full error message
			range.selectNode(document.querySelector(".svg-reader"));

			(document.body as any).PnSelectionData = {content, range};

			// And now we can open the popup
			return true;
		}

		return await super.mouseUp(event, bypassHighlightRules, isSelectionEqual, isPageCoordEqual, page, processOrgProxy);
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'annotation' implicitly has an 'any' typ... Remove this comment to see the full error message
	alterNewHighlight(annotation) {
		const {content, range} = (document.body as any).PnSelectionData;

		if (content === undefined)
			return;

		annotation.selection = Selection.GetSelectionFromRange(range);
		annotation.selectedText = content;
	}

	getCopyButtonLabel() {
		return "Copy With Citation";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'selectedText' implicitly has an 'any' t... Remove this comment to see the full error message
	async copySelectionToClipboard(selectedText, document, loadCitation) {
		const {content} = document.body.PnSelectionData;
		if (content !== undefined) {
			selectedText = (content).trim();
			loadCitation = null;
		}

		super.copySelectionToClipboard(selectedText, document, loadCitation);
	}
}

export default Unizin;
